import router from './router'
import { LoadingBar } from '@varlet/ui'

LoadingBar.setDefaultOptions({
  color: '#B7987C',
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title as string || '群英榜'
  LoadingBar.start()
  next()
})

router.afterEach(() => {
  LoadingBar.finish()
})
